import { FC } from 'react';

import { Box, css, styled } from '@mui/material';

import { IMMEDIATE_ATTENTION, AlertText } from 'constants/alertBadge.const';

import { Text } from 'components/UIkit/atoms/Text';

interface AlertBadgeProps {
  alertText: AlertText;
}

export const AlertBadge: FC<AlertBadgeProps> = ({ alertText }) => {
  return (
    <StyledAlertContainer alertText={alertText}>
      <Text color={alertText === IMMEDIATE_ATTENTION ? 'white' : 'primary'} variant="h4">
        {alertText}
      </Text>
    </StyledAlertContainer>
  );
};

const StyledAlertContainer = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'alertText'
})<{
  alertText: AlertText;
}>(
  ({ theme, alertText }) => css`
    width: 218px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: ${theme.borderRadius.xSmall};
    background-color: ${alertText === IMMEDIATE_ATTENTION
      ? theme.palette.error.dark
      : theme.palette.warning.main};
    height: 24px;
    flex-shrink: 0;
    margin-left: ${theme.spacing(28)};
  `
);
